/* eslint-disable no-useless-escape */
/* eslint-disable import/prefer-default-export */
const invalidCharactersRegex = /[\:\/\?\*\"\|\<\>\&\\]/;

export {
  invalidCharactersRegex
};
